import { render } from "./SingleStrategySetup.vue?vue&type=template&id=091c5d59&scoped=true"
import script from "./_SingleStrategySetup.js?vue&type=script&lang=js&external"
export * from "./_SingleStrategySetup.js?vue&type=script&lang=js&external"

import "./_SingleStrategySetup.less?vue&type=style&index=0&id=091c5d59&lang=less&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-091c5d59"]])

export default __exports__